'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');let

WaypointViewModelService=class WaypointViewModelService extends BaseService{
static get $inject(){return[]}

constructor(){
super();
}

_getStatusAt(time,statusTransitions){
for(let status of statusTransitions){
if(new Date(status.time).getTime()===new Date(time).getTime()){
return status;
}
}

return null;
}

_getStatusBefore(time,statusTransitions){
let lastStatus;

for(let status of statusTransitions){
if(new Date(status.time).getTime()===new Date(time).getTime()){
return lastStatus;
}

if(lastStatus===void 0||lastStatus.value!==status.value){
lastStatus=status;
}
}

return null;
}

_getDurationString(duration){
let{hours,minutes}=duration;
let hoursString=hours>=1?`${hours} h`:null;
let minutesString=minutes>0?`${minutes} min`:null;

return _.compact([hoursString,minutesString]).join(' ');
}

_getAddressString(locationObject){
let{street,city,state,zip}=locationObject;

return _.compact([street,city,state,zip]).join(', ');
}

createWaypointViewModelsForRoute(stops,statusTransitions,onBeginEdit){
let stopWaypoints=stops.map(stop=>{
let startTime=new Date(stop.duration.start);

let addressString=this._getAddressString(stop.location);

let typeString=null;

if(stop.subType==='none'){
typeString='NotProvided';
}else if(stop.stopType==='rest'){
typeString='Rest stop';
}else if(stop.subType==='drophook'){
typeString='Drop and Hook';
}else if(stop.subType!=='none'){
typeString=_.upperFirst(stop.subType);
}

let durationString;

if(stop.subType==='none'){
durationString=null;
}else if(stop.subType==='drophook'){
durationString='45 min';
}else if(stop.subType==='load'||stop.subType==='unload'){
durationString='2h';
}else{
durationString=this._getDurationString(new TimeInterval(stop.duration).duration);
}

return{
name:_.exists(stop.location.name)?stop.location.name:null,
time:startTime,
timezone:stop.timezone,
address:addressString,
type:typeString,
duration:durationString,
isBreak:stop.stopType==='rest'};

});

let drivingWaypoints=[];

let lastWaypoint=null;
for(let waypoint of stopWaypoints){
let lastStatus=this._getStatusBefore(waypoint.time,statusTransitions);
let currentStatus=this._getStatusAt(waypoint.time,statusTransitions);

if(_.exists(lastStatus)&&lastStatus.value===2){
let statusInterval=new TimeInterval(lastStatus.time,currentStatus.time);

drivingWaypoints.push({
name:`Depart ${lastWaypoint.name||lastWaypoint.address}`,
time:new Date(lastStatus.time),
timezone:lastWaypoint.timezone,
address:null,
duration:this._getDurationString(statusInterval.duration),
type:'Drive',
isBreak:!1});

}
lastWaypoint=waypoint;
}

let combinedWaypoints=stopWaypoints.concat(drivingWaypoints);
let sortedCombinedWaypoints=_.sortBy(combinedWaypoints,wp=>new Date(wp.time).getTime());

if(_.first(sortedCombinedWaypoints).type==='NotProvided'){
sortedCombinedWaypoints=_.tail(sortedCombinedWaypoints);
}

let originWaypoint=_.first(sortedCombinedWaypoints);
let destinationWaypoint=_.last(sortedCombinedWaypoints);

if(destinationWaypoint.type==='NotProvided'){
destinationWaypoint.type='Trip Complete';
}else
{
sortedCombinedWaypoints.push({
type:'Trip Complete',
name:destinationWaypoint.name,
address:destinationWaypoint.address,
time:new Date(_.last(stops).duration.end),
timezone:destinationWaypoint.timezone,
duration:null,
isBreak:!1});

destinationWaypoint=_.last(sortedCombinedWaypoints);
}

let editableWaypoints=[originWaypoint,destinationWaypoint];
for(let editableWaypoint of editableWaypoints){
editableWaypoint.beginEdit=()=>{
let displayTimeWithoutSeconds=pulsarDate(editableWaypoint.time).fromTimeZoneOffsetToLocalOffset(editableWaypoint.timezone||'local');
displayTimeWithoutSeconds.setSeconds(0);
displayTimeWithoutSeconds.setMilliseconds(0);
editableWaypoint.edits={
address:editableWaypoint.address,
displayTime:displayTimeWithoutSeconds};

onBeginEdit(editableWaypoint);
};
}

return sortedCombinedWaypoints;
}};


module.exports=WaypointViewModelService;
//# sourceMappingURL=waypointViewModelService.js.map
